"use strict";

exports.__esModule = true;
var _ClassificationContext = require("./ClassificationContext");
Object.keys(_ClassificationContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationContext[key]) return;
  exports[key] = _ClassificationContext[key];
});
var _ClassificationController = require("./ClassificationController");
Object.keys(_ClassificationController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClassificationController[key]) return;
  exports[key] = _ClassificationController[key];
});